import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import api from "../../api/api";
import {
  ArrowLeft,
  FileText,
  Calendar,
  ArrowRightLeft,
  Building,
  Send,
  RotateCcw,
  Truck,
  User,
  Edit,
  Printer,
} from "lucide-react";

/* === INLINE PROFESSIONAL CSS === */
const styles = `
body {
  font-family: "Inter", sans-serif;
  background-color: #f7f9fc;
  color: #1f2937;
  margin: 0;
  padding: 0;
}
.container {
  max-width: 700px;
  margin: 40px auto;
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
}
.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #2157ebff;
  border: 1px solid #2157ebff;
  color: #e7edeeff;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 1rem;
}
.back-button:hover {
  background: #2157ebff;
  transform: translateX(-3px);
}
h2.title {
  font-size: 1.2rem;
  color: #1e3a8a;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 10px;
  border-bottom: 2px solid #dbeafe;
  margin-bottom: 20px;
}
h3.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #374151;
  font-size: 1rem;
  margin-top: 20px;
}
h3.section-title span {
  width: 4px;
  height: 20px;
  background-color: #2563eb;
  border-radius: 9999px;
}
label {
  font-size: 0.85rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
  display: block;
}
input[type="text"],
input[type="date"],
textarea {
  width: 90%;
  padding: 10px 12px 10px 38px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background-color: white;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  margin-bottom: 14px;
}
input:focus, textarea:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37,99,235,0.15);
}
textarea {
  resize: none;
  min-height: 70px;
}
.relative { position: relative; }
.icon-left {
  position: absolute;
  inset-y: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.btn-primary {
  background: #2563eb;
  color: white;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 0.95rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 3px 8px rgba(37,99,235,0.25);
}
.btn-primary:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
}
.section { margin-bottom: 20px; }
.react-select__control {
  border-radius: 8px !important;
  border-color: #d1d5db !important;
  box-shadow: none !important;
  min-height: 40px;
}
.react-select__control:hover {
  border-color: #2563eb !important;
}
.react-select__menu { border-radius: 8px; z-index: 100; }
.react-select__option--is-focused {
  background-color: #eff6ff !important;
  color: #1e3a8a !important;
}
.react-select__single-value { color: #1f2937 !important; }
.react-select__placeholder { color: #9ca3af !important; }
`;

const StyleInjector = () => <style>{styles}</style>;

export default function AssetMovement() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isReturnable, setIsReturnable] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [returnables, setReturnables] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [assetList, setAssetList] = useState([]);

  const [selectedReason, setSelectedReason] = useState(null);
  const [selectedToLocation, setSelectedToLocation] = useState(null);
  const [selectedMovedBy, setSelectedMovedBy] = useState(null);
  const [selectedAuthorizedBy, setSelectedAuthorizedBy] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);

  const [editData, setEditData] = useState(null);
  const currentDate = new Date().toISOString().split("T")[0];
const [generatedDocNo, setGeneratedDocNo] = useState("");

  const isReturnReason =
  selectedReason?.label === "Return from Supplier/Customer";


  useEffect(() => {
    const userName = sessionStorage.getItem("userName");
    if (!userName) return;


    

    const incomingEdit = location.state?.editData || null;
    if (incomingEdit) setEditData(incomingEdit);

    api
      .GetAssetMovement(userName)
      .then((res) => {
        const table = res.Table || [];
        const table1 = res.Table1 || [];
        const table2 = res.Table2 || [];
        const table3 = res.Table3 || [];
        const table4 = res.Table4 || [];
const table5 = res.Table5 || [];

        const reasonsArr = table.map((x) => ({ value: x.Reason, label: x.Reason }));
        const returnablesArr = [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ];
        const employeesArr = table2.map((x) => ({ value: x.Eid, label: x.Ename }));
        const destinationsArr = table3.map((x) => ({ value: x.Vid, label: x.Vname }));
       const assetListArr = table4.map((x) => ({
  value: x.AssetId,
  label: `${x.AssetName} (${x.SerialNo})`,
  assetName: x.AssetName, // ✅ store actual name separately
}));
const generatedDocNo = table5.length > 0 ? table5[0].DocNo : "";

        setReasons(reasonsArr);
        setReturnables(returnablesArr);
        setEmployees(employeesArr);
        setDestinations(destinationsArr);
        setAssetList(assetListArr);

           setGeneratedDocNo(generatedDocNo);

           
        // ✅ Populate edit values *after* options are ready
        if (incomingEdit) {
          setSelectedReason(
            reasonsArr.find((r) => r.label === incomingEdit.MovementReason) || null
          );
          setSelectedToLocation(
            destinationsArr.find(
              (d) => `${d.value}` === `${incomingEdit.ToLocationId}`
            ) || null
          );
          setSelectedMovedBy(
            employeesArr.find((e) => `${e.value}` === `${incomingEdit.MovedByID}`) || null
          );
          setSelectedAuthorizedBy(
            employeesArr.find(
              (e) => `${e.value}` === `${incomingEdit.AuthorizedByID}`
            ) || null
          );
          setSelectedAsset(
            assetListArr.find(
              (a) => `${a.value}` === `${incomingEdit.AssetId}`
            ) || null
          );

          const matchedReturnable =
            returnablesArr.find(
              (r) =>
                r.value.toLowerCase() ===
                (incomingEdit.IsReturnable ? "yes" : "no")
            ) || null;
          setIsReturnable(matchedReturnable);
        }
      })
      .catch((err) => console.error("❌ Error fetching dropdown data:", err));
  }, [location]);

  /* === SAVE / UPDATE === */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const userName = sessionStorage.getItem("userName");

    const payload = {
      Sp_SqlAction: editData ? "UPDATE" : "INSERT",
      MovementID: editData?.MovementID || 0,
      MovementDocNo: form.get("docNo"),
      MovementDate: form.get("movementDate"),
      MovementReason: selectedReason?.label || "",
      FromLocation: form.get("fromLocation"),
      ToLocationId: selectedToLocation?.value || "",
      ToLocation: selectedToLocation?.label || "",
      IsReturnable: isReturnable?.value === "Yes" ? 1 : 0,
      ExpectedReturnDate: form.get("returnDate"),
      AuthOrderNo: form.get("authOrder"),
      TransportMode: form.get("transportMode"),
      MovedByID: selectedMovedBy?.value || "",
      MovedBy: selectedMovedBy?.label || "",
      AuthorizedByID: selectedAuthorizedBy?.value || "",
      AuthorizedBy: selectedAuthorizedBy?.label || "",
      AssetId: selectedAsset?.value || 0,
     AssetName: selectedAsset?.assetName || "",
      ConditionNotes: form.get("condition"),
      GeneralNotes: form.get("notes"),
      UserName: userName,
    };

    try {
      const res = await api.SaveAssetMovement(payload);
      console.log("✅ Saved:", res);
      alert(editData ? "Asset Movement Updated Successfully!" : "Asset Movement Saved Successfully!");
      navigate("/AssetMovementList");
    } catch (error) {
      console.error("❌ Save failed:", error);
      alert("Save failed. Please try again.");
    }
  };

  return (
    <div className="container">
      <StyleInjector />
      <button className="back-button" onClick={() => navigate("/AssetMovementList")}>
        <ArrowLeft size={18} /> Back
      </button>

      <h2 className="title">
        <FileText className="w-5 h-5 text-blue-500" />
        {editData ? "Edit Asset Movement" : "New Asset Movement"}
      </h2>

      <form onSubmit={handleSubmit}>
        {/* === MOVEMENT DETAILS === */}
        <Section title="Movement Details">
<FormInput
  icon={FileText}
  label="Document No."
  name="docNo"
  value={editData ? editData.MovementDocNo : generatedDocNo}
  required
  readOnly
/>
          <FormInput
            icon={Calendar}
            label="Movement Date"
            name="movementDate"
            type="date"
            defaultValue={editData?.MovementDate?.split("T")[0] || currentDate}
            required
          />
          <FormSelect
            icon={ArrowRightLeft}
            label="Reason"
            name="reason"
            options={reasons}
            placeholder="Select reason..."
            value={selectedReason}
            onChange={setSelectedReason}
          />
        </Section>

        {/* === LOCATION INFO === */}
        
<FormInput
  icon={Building}
  label={isReturnReason ? "To Destination" : "From Location"}
  name="fromLocation"
  defaultValue={
    location.state?.editData
      ? location.state.editData.FromLocation // edit → show DB value
      : "Our Factory" // new → default
  }
  required
/>
          <FormSelect
  icon={Send}
  label={isReturnReason ? "From Location" : "To Destination"}
  name="toLocation"
  options={destinations}
  placeholder="Select destination..."
  value={selectedToLocation}
  onChange={setSelectedToLocation}
/>
        

        {/* === RETURN / AUTH === */}
       
          <FormSelect
            icon={RotateCcw}
            label="Returnable?"
            name="isReturnable"
            options={returnables}
            placeholder="Select..."
            value={isReturnable}
            onChange={setIsReturnable}
          />
          <FormInput
            icon={Calendar}
            label="Expected Return"
            name="returnDate"
            type="date"
            defaultValue={editData?.ExpectedReturnDate?.split("T")[0] || currentDate}
          />
          <FormInput
            icon={FileText}
            label="Auth. Ref"
            name="authOrder"
            defaultValue={editData?.AuthOrderNo || ""}
            placeholder="PO/Service Order"
          />
       

        {/* === PERSONNEL === */}
        <Section title="Personnel">
          <FormInput
            icon={Truck}
            label="Transport Mode"
            name="transportMode"
            defaultValue={editData?.TransportMode || ""}
            placeholder="Company Van"
          />
          <FormSelect
            icon={User}
            label="Moved By"
            name="movedBy"
            options={employees}
            placeholder="Select MoveBy..."
            value={selectedMovedBy}
            onChange={setSelectedMovedBy}
          />
          <FormSelect
            icon={User}
            label="Authorized By"
            name="authorizedBy"
            options={employees}
            placeholder="Select authorizedBy..."
            value={selectedAuthorizedBy}
            onChange={setSelectedAuthorizedBy}
          />
        </Section>

        {/* === ASSET === */}
        <Section title="Asset to Move">
          <FormSelect
            icon={FileText}
            label="Asset"
            name="selectedAsset"
            options={assetList}
            placeholder="Select asset..."
            value={selectedAsset}
            onChange={setSelectedAsset}
          />
        </Section>

        {/* === NOTES === */}
        <Section title="Additional Info">
          <FormInput
            icon={Edit}
            label="Condition"
            name="condition"
            defaultValue={editData?.ConditionNotes || ""}
            placeholder="Good, clean, packed securely"
          />
          <label>
            <Edit className="w-4 h-4 text-blue-500 inline mr-1" /> Notes
          </label>
          <textarea
            name="notes"
            rows="3"
            defaultValue={editData?.GeneralNotes || ""}
            placeholder="Add remarks..."
          ></textarea>
        </Section>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "25px",
            borderTop: "1px solid #e5e7eb",
            paddingTop: "15px",
          }}
        >
          <button type="submit" className="btn-primary">
            {/* <Printer className="w-5 h-5" /> {editData ? "Update & Print" : "Save & Print"} */}
              {editData ? "Update" : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}

/* === REUSABLE COMPONENTS === */
const Section = ({ title, children }) => (
  <div className="section">
    <h3 className="section-title">
      <span></span> {title}
    </h3>
    {children}
  </div>
);

const FormInput = ({ icon, label, name, type = "text", ...rest }) => {
  const Icon = icon;
  return (
    <div>
      <label>{label}</label>
      <div className="relative">
        <div className="icon-left">
          <Icon size={16} color="#9ca3af" />
        </div>
        <input type={type} id={name} name={name} {...rest} />
      </div>
    </div>
  );
};

const FormSelect = ({ icon, label, name, options = [], placeholder, value, onChange }) => {
  const Icon = icon;
  return (
    <div>
      <label>{label}</label>
      <div className="relative">
        <div className="icon-left">
          <Icon size={16} color="#9ca3af" />
        </div>
        <Select
          classNamePrefix="react-select"
          options={options}
          placeholder={placeholder}
          value={value}
          isClearable
          styles={{
            control: (base) => ({
              ...base,
              paddingLeft: "28px",
            }),
          }}
          onChange={(selectedOption) => onChange && onChange(selectedOption)}
          name={name}
        />
      </div>
    </div>
  );
};




 
